export const GET_NOTES_SUCCEED = 'Notes/GET_NOTES_SUCCEEDED';
export const GET_NOTES_ERROR = 'Notes/GET_NOTES_ERROR';

export const GET_NOTE_SUCCEED = 'Note/GET_NOTE_SUCCEEDED';
export const GET_NOTE_ERROR = 'Note/GET_NOTE_ERROR';

export const EDIT_NOTE_SUCCEED = 'Note/EDIT_NOTE_SUCCEEDED';
export const EDIT_NOTE_ERROR = 'Note/EDIT_NOTE_ERROR';

export const DELETE_NOTE_SUCCEED = 'Note/DELETE_NOTE_SUCCEEDED';
export const DELETE_NOTE_ERROR = 'Note/DELETE_NOTE_ERROR';

export const CREATE_NOTE_SUCCEED = 'Note/CREATE_NOTE_SUCCEEDED';
export const CREATE_NOTE_ERROR = 'Note/CREATE_NOTE_ERROR';

export const LOADING_STATE = 'Note/LOADING_STATE';